import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LoggerFactory } from '@elderbyte/ts-logger';
import { FileUploadRequest } from '../../../shared/model/request/file-upload-request';
import { FileUploadService } from '../../providers/file-upload.service';
import { Observable, Subscriber } from 'rxjs';
import { Store } from '@ngxs/store';
import { LoaderHide, LoaderProgress, LoaderShow } from '../../../state/loader/loader.actions';

@Component({
  selector: 'tcc-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnInit {

  private static logger = LoggerFactory.getLogger('FileUploadComponent');

  @Input() disabled: boolean;
  @Input() placeholder: string;
  @Input() filter = 'application/zip,application/x-zip-compressed';
  @Input() request: FileUploadRequest;

  @Output() progress = new EventEmitter<number>();


  constructor(public _fileUploadService: FileUploadService,
              private store: Store) {
  }


  ngOnInit() {
  }


  onFileSelect(file: File) {
    this.request.uploadFile = file;
  }

  uploadFile(endpoint: string): Observable<any> {
    this.store.dispatch(new LoaderShow('determinate'));

    return new Observable<any>((subscriber: Subscriber<any>) => {
      const progress = (loaded: number, total: number) => {
        const percentage = Math.floor((loaded * 100) / total);
        this.store.dispatch(new LoaderProgress(percentage));
        this.progress.emit(percentage);
      };

      this._fileUploadService.uploadFile(this.request, endpoint, progress)
        .subscribe(
          (result: any) => {
            // Hide loader
            this.store.dispatch(new LoaderHide());

            FileUploadComponent.logger.debug(`Successfully uploaded input file: ${JSON.stringify(result)}`);

            subscriber.next(result);
            subscriber.complete();
          },
          (error: any) => {
            FileUploadComponent.logger.error(`Failed to upload input file: ${JSON.stringify(error)}`);

            subscriber.error(error);
          }
        );
    });
  }

}
